import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  margin: 0;
  width: 29.1vw;
  height: 52.585em;
  font-size: 12px;
  background: #6089BB;
  position: relative;

  .hide {
    display: none;
  }
  
  p, pre {
    font-family: 'Nunito', 'cursive';
  }

  pre {
    overflow-x: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .logo-rodape {
    width: 10em;
    position: absolute;
    top: 49.3em;
    left: 1.5em;
  }

  .barra-sup {
    background: #1E4778;
    width: 12em;
    height: 14px;
    content: "";
  }

  .barra-sup3 {
    background: #1E4778;
    width: 12em;
    height: 14px;
    content: "";
    position: absolute;
    bottom: 0em;
    left: 25.2em;
  }

  .barra-sup2 {
    background: #4D78AD;
    width: 9em;
    height: 9px;
    content: "";
    top: 0;
    left: 12em;
    position: absolute;
  }

  .barra-sup4 {
    background: #4D78AD;
    width: 9em;
    height: 9px;
    content: "";
    position: absolute;
    bottom: 0em;
    left: 16.19em;
  }

  .header {
    margin-top: -2em;
    padding: 1.6em;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    .text {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;

      .titulo {
        font-size: 9px;
        color: #FFFFFF;
        font-weight: 600;
      }

      .titulo-data {
        font-size: 9px;
        color: #D0D0D0;
      }
    }
  }
  
  .body {
    padding: 0.5em 2em;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 51em;

    .mid {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 35em;

      img {
        width: 30em;
      }
    }
    
    .bottom {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      width: 24vw;

      .titulo-contato {
        font-size: 12px;
        color: #FFFFFF;
        font-weight: 600;
      }
        
      .titulo {
        font-size: 9px;
        color: #FFFFFF;
        font-weight: 600;
        margin-top: 0.15rem;
      }
    }
  }
`;


export const Complemento = styled.div`
  content: "";
  width: 100%;
  background: #FFFFFF;

  ${props => {
    return `height: ${props?.height}px;`;
  }}
`